import { createContainer } from 'unstated-next'
import { useState } from 'react'
import { useToggle } from 'react-use'
import useSWR from 'swr'
import UserStoreNext from '../../../../../UserAuth/Store/user-store-next'

const RecordedCourseDashboardStore = createContainer(() => {
  const [active, setActive] = useState(0)
  const [expanded, toggleExpanded] = useToggle(true)
  const [showRegistrationModal, toggleRegistrationModal] = useToggle(false)

  const { data: userProfile } = UserStoreNext.useContainer()

  const { data: activeSubscription } = useSWR(
    userProfile?.id ? `/subscriptions` : null,
  )
  return {
    active,
    expanded,
    setActive,
    toggleExpanded,
    activeSubscription,
    showRegistrationModal,
    toggleRegistrationModal,
  }
})

export default RecordedCourseDashboardStore
